import { Injectable } from '@angular/core';
import { OnyxEvent } from '../models/event';
import { AppAuthHttpService } from '../../http/app.auth.http.service';
import { EventStore } from './event.store';
import { EnvironmentConfiguration } from '../../environment/services/environment.configuration';
import { ResponseUtilService } from '../../shared/utils/response-util.service';
import { Observable } from 'rxjs/Observable';
import { DateRoomType } from '../models/date-room-type';
import { Headers, RequestOptions, Response } from '@angular/http';
import { CustomLabelRequest } from '../models/custom-label-request';
import { CustomLabelResponse } from '../models/custom-label-response';
import { MSTR } from '../models/mstr';

@Injectable()
export class CustomLabelHttpService {

  private customLabelUrl: string = this.environment.baseUrl + '/api/customer-config/customer-labels';
  private selectedEvent: OnyxEvent;

  constructor(private http: AppAuthHttpService,
              private eventStore: EventStore,
              private environment: EnvironmentConfiguration,
              private responseUtilService: ResponseUtilService) {
    eventStore.selectedEvent.map( event => this.selectedEvent = event);
  }

  geCustomLabels(request: CustomLabelRequest): Observable<CustomLabelResponse> {
    return this.http.post(`${this.customLabelUrl}`, JSON.stringify(request.toJS()), this.jsonOptions)
      .map(response => response.json())
      .catch(response => this.responseUtilService.handleError(response)).share();
  }

  private get jsonOptions(): RequestOptions {
    const headers = new Headers({'Content-Type': 'application/json'});
    const options = new RequestOptions({headers: headers});
    return options;
  }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/service/custom-label.http.service.ts